import { CourseKitClient } from '@coursekit/client'

const courseOptions = {
  schoolId: process.env.NEXT_PUBLIC_SCHOOL_ID,
  devMode: process.env.NEXT_PUBLIC_COURSE_DEV_MODE === 'true',
}
const ck = new CourseKitClient(courseOptions)
// console.log('CourseKitClient loaded %o', courseOptions)

const fetchUser = async () => {
  const { status, user } = await ck.loadUser()
  if (status === 500) throw new Error('Server error')
  return { status, user }
}

const fetchCourseSummaries = async () => {
  const { status, courses } = await ck.loadCourseSummaries()
  if (status === 500) throw new Error('Server error')
  return { courses, status }
}

const fetchUserAndCourseSummaries = async () => {
  // { status, user }
  const userRes = await ck.loadUser()
  // { status, courses }
  const courseRes = await ck.loadCourseSummaries()
  if (userRes.status === 500 || courseRes.status === 500)
    throw new Error('Server error')

  // console.log({ userRes, courseRes })
  return { userRes, courseRes }
}

const fetchCourse = async ({ courseId }) => {
  const { status, course } = await ck.loadCourse(courseId)
  if (status === 404 || status === 500) throw new Error('Server error')
  return { course, status }
}

const fetchUserAndCourse = async ({ courseId }) => {
  const userRes = await ck.loadUser()
  const courseRes = await ck.loadCourse(courseId)
  if (userRes.status === 500 || courseRes.status === 500)
    throw new Error('Server error')

  // console.log({ userRes, courseRes })
  return { userRes, courseRes }
}

const fetchLesson = async ({ courseId, lessonId }) => {
  const { status, lesson } = await ck.loadLesson(courseId, lessonId)
  if (status === 404 || status === 500) throw new Error('Server error')
  return { status, lesson }
}

const fetchCourseLessonAndUser = async ({ courseId, lessonId }) => {
  const { status, user } = await fetchUser()
  const result = await Promise.all([
    await fetchCourse({ courseId }),
    await fetchLesson({ courseId, lessonId }),
    // await fetchUser(),
  ])
  return {
    courseStatus: result[0].status,
    course: result[0].course,
    lessonStatus: result[1].status,
    lesson: result[1].lesson,
    userStatus: status,
    user: user,
  }
}

export {
  ck,
  fetchCourseSummaries,
  fetchCourse,
  fetchLesson,
  fetchCourseLessonAndUser,
  fetchUser,
  fetchUserAndCourse,
  fetchUserAndCourseSummaries,
}
